import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { startApp, startAppCancel } from '../../actions/StartApp.Actions';
import { searchParameterSelector } from '../../selectors/RouterSelector';
import Modal from '../../components/Modal';
import './LoadingModal.sass';

class LoadingModal extends Component {
  constructor(props) {
    super(props);
    this.handleRestartApp = this.handleRestartApp.bind(this);
    this.handleCancelApp = this.handleCancelApp.bind(this);
    this.mapPropsToContent = this.mapPropsToContent.bind(this);
  }

  handleRestartApp() {
    const { dispatch } = this.props;
    const search = searchParameterSelector(this.props);
    dispatch(startApp(search));
  }

  handleCancelApp() {
    const { dispatch } = this.props;
    dispatch(startAppCancel());
  }

  mapPropsToContent() {
    const { loading, error: { type, message } } = this.props;
    if (type) {
      return (
        <span>
          {message}
          <button
            className="retry-btn"
            onClick={this.handleRestartApp}
          >
            Retry Connection
          </button>
        </span>
      );
    } else if (loading) {
      return (
        <span>
          Loading Data
          <span className="fa fa-spinner rotating" />
          <button
            className="cancel-btn"
            onClick={this.handleCancelApp}
          >
            Cancel
          </button>
        </span>
      );
    }
    return <span />;
  }

  render() {
    const { loading, error: { type } } = this.props;
    return (
      <Modal
        open={loading || (!!type && type === 'START_APP_ERROR')}
        showCloseButton={false}
        width="400pt"
        height="75pt"
        className={`start-app-loading-modal ${type ? 'error' : ''}`}
      >
        {this.mapPropsToContent()}
      </Modal>
    );
  }
}

LoadingModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool.isRequired
};

function mapStateToProps({ StartApp: { loading, error } }) {
  return { loading, error };
}

export default withRouter(connect(mapStateToProps)(LoadingModal));



// WEBPACK FOOTER //
// ./src/containers/Main/LoadingModal.jsx